import React, { createContext, useContext, useState, useEffect } from 'react';
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
  const [user, setUser]   = useState(null);
  const [token, setToken] = useState(localStorage.getItem('hrn_token'));
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) { setUser(payload); }
        else { logout(); }
      } catch { logout(); }
    }
    setLoading(false);
  }, [token]);
  async function login(username, password) {
    const res  = await fetch('/api/admin/login', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ username, password }) });
    const data = await res.json();
    if (data.error) throw new Error(data.error);
    localStorage.setItem('hrn_token', data.token);
    setToken(data.token); setUser(data.user);
    return data.user;
  }
  function logout() { localStorage.removeItem('hrn_token'); setToken(null); setUser(null); }
  function can(permission) {
    if (!user) return false;
    if (user.role === 'super_admin') return true;
    const perms = user.permissions || [];
    return perms.includes('all') || perms.includes(permission);
  }
  return <AuthContext.Provider value={{ user, token, loading, login, logout, can }}>{children}</AuthContext.Provider>;
}
export const useAuth = () => useContext(AuthContext);